import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import store from "@/store";
import { i18n } from "vue-lang-router";

export default class ApiClient {
  protected readonly _axiosInstance: AxiosInstance;

  protected constructor(options: any) {
    this._axiosInstance = axios.create(options);
  }

  protected static of(options: any): ApiClient {
    return new ApiClient(options);
  }

  get(path: string, config?: AxiosRequestConfig): Promise<any> {
    return this._axiosInstance.get(path, config).then(this.successHandler, this.errorHandler);
  }

  delete(path: string, config?: AxiosRequestConfig): Promise<any> {
    return this._axiosInstance.delete(path, config).then(this.successHandler, this.errorHandler);
  }

  post(path: string, data?: unknown = {}, config?: AxiosRequestConfig): Promise<any> {
    return this._axiosInstance.post(path, data, config).then(this.successHandler, this.errorHandler);
  }

  put(path: string, data?: unknown = {}, config?: AxiosRequestConfig): Promise<any> {
    return this._axiosInstance.put(path, data, config).then(this.successHandler, this.errorHandler);
  }

  patch(path: string, data?: unknown = {}, config?: AxiosRequestConfig): Promise<any> {
    return this._axiosInstance.patch(path, data, config).then(this.successHandler, this.errorHandler);
  }

  successHandler(response: AxiosResponse): any {
    if (response.headers["x-remote-address"]) {
      sessionStorage.setItem("ShopperIP", response.headers["x-remote-address"]);
    }

    let fileName = "";
    const disposition = response.headers["content-disposition"];

    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, "");
      return { fileName, blob: response.data };
    }
    return response.data;
  }

  errorHandler(error: any): void {

    if (error.message.cancel) {
      throw { status: 499, message: "Operation canceled due to new request." };
    }
    if (error.response) {
      const data: any = error.response.data || {};
      if (data.status === 401 && (data.path !== "/storefront/customers/one-time-password" && data.path !== "/storefront/customers/sign-in")) {
        store.dispatch("setCustomer", null);
        store.dispatch("sendNotification", { type: "danger", message: i18n.t("errors.unauthorized"), icon: "error" });
      }

      if (!data.status) {
        data.status = error.response.status;
        throw  data;
      } else {
        throw { status: data.status, message: data.message };
      }
    }

    if (error.request) {
      throw { status: -1 };
    }
  }
}
